import { useId } from 'react';
import type { SiteBriefFontCatalogEntryType } from '../api.types';
import type { ChoiceCardChromeType } from '../utils/siteBriefChoiceChrome';
import SiteBriefFontSpecimen from './SiteBriefFontSpecimen';

type SiteBriefFontConstructorProps = {
  chrome: ChoiceCardChromeType;
  // null while the catalog is loading.
  catalog: SiteBriefFontCatalogEntryType[] | null;
  failed: boolean;
  heading: string;
  body: string;
  disabled: boolean;
  onChange: (heading: string, body: string) => void;
};

// Two pickers over the same font catalog the model proposes from, with a live specimen.
export default function SiteBriefFontConstructor({
  chrome,
  catalog,
  failed,
  heading,
  body,
  disabled,
  onChange,
}: SiteBriefFontConstructorProps) {
  const headingId = useId();
  const bodyId = useId();

  if (failed) {
    return <p className="sb-font-ctor__note">{chrome.catalogFailed}</p>;
  }
  if (!catalog) {
    return <p className="sb-font-ctor__note">{chrome.catalogLoading}</p>;
  }

  return (
    <div className="sb-font-ctor">
      <div className="sb-font-ctor__row">
        <div className="sb-font-ctor__field">
          <label htmlFor={headingId}>{chrome.headingFont}</label>
          <select
            id={headingId}
            value={heading}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value, body)}
          >
            {catalog
              .filter((font) => font.use !== 'body')
              .map((font) => (
                <option key={font.family} value={font.family}>
                  {font.family}
                </option>
              ))}
          </select>
        </div>
        <div className="sb-font-ctor__field">
          <label htmlFor={bodyId}>{chrome.bodyFont}</label>
          <select
            id={bodyId}
            value={body}
            disabled={disabled}
            onChange={(event) => onChange(heading, event.target.value)}
          >
            {catalog
              .filter((font) => font.use !== 'heading')
              .map((font) => (
                <option key={font.family} value={font.family}>
                  {font.family}
                </option>
              ))}
          </select>
        </div>
      </div>
      <SiteBriefFontSpecimen chrome={chrome} heading={heading} body={body} />
    </div>
  );
}
